import { render, staticRenderFns } from "./AvailableSystemRecordsList.vue?vue&type=template&id=7c787c2c&scoped=true&"
import script from "./AvailableSystemRecordsList.vue?vue&type=script&lang=js&"
export * from "./AvailableSystemRecordsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c787c2c",
  null
  
)

export default component.exports